import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { storeRedirectPath } from '../utils/redirectUtils';

const ProtectedRoute = ({ children, isAuthenticated }) => {
  const location = useLocation();

  if (!isAuthenticated) {
    // Store the current path for redirect after login
    storeRedirectPath(location.pathname + location.search);
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute; 